<div class="font-inter">
  <div class="w-screen max-w-xl"></div>
  <div class="mb-2 text-xs">Select phase:</div>

  <div class="flex">
    @for (phase of phases; track phase) {
      <div class="flex flex-1 items-center">
        <input
          name="phases"
          type="radio"
          class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
          [id]="phase.cat_id"
          [value]="phase"
          [(ngModel)]="selectedPhase"
        />
        <label class="ml-2" [for]="phase.cat_id">
          <span class="block text-sm font-medium text-gray-700">{{ phase.name }}</span>
        </label>
      </div>
    }
  </div>

  @if (selectedPhase && selectedPhase.name !== 'Custom') {
    <div class="mt-8 flex items-center">
      <div class="w-32 rounded-md border bg-aux-gray-light p-4 text-sm font-medium">
        {{ selectedPhase.firstMilestone?.name }}
        <span class="block text-xs">({{ selectedPhase.firstMilestone?.start_date | date }})</span>
      </div>
      <aux-icon name="ArrowRight" class="mx-4" />
      <div class="w-32 rounded-md border bg-aux-gray-light p-4 text-sm font-medium">
        {{ selectedPhase.lastMilestone?.name }}
        <span class="block text-xs">({{ selectedPhase.lastMilestone?.end_date | date }})</span>
      </div>
    </div>
  }

  @if (!selectedPhase || selectedPhase.name === 'Custom') {
    <div class="mt-6 grid grid-cols-2 gap-5">
      <div class="h-96 space-y-2 overflow-auto p-2">
        <div class="text-xs">Select starting milestone/date:</div>

        <div class="flex flex-1 items-center" (click)="selectDateInputRadio(true)">
          <input
            name="start-milestone-date"
            type="radio"
            class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
            [value]="customMilestoneDatepickerType.START_DATE"
            [(ngModel)]="selectedCustomStartMilestone"
          />

          <div class="ml-2">
            <aux-input
              class="w-40"
              [type]="'date'"
              [placeholder]="formControlConstants.PLACEHOLDER.DATE"
              [formControl]="customStartDateControl"
              [disabled]="isCustomStartDateControlDisabled()"
              [dateCompareValidation]="trialTimelinePeriod"
              dateCompareError="trialTimelinePeriod"
            />
          </div>
        </div>

        @for (milestone of allMilestones; track milestone) {
          <div class="flex flex-1 items-center">
            <input
              name="start-milestone-date"
              type="radio"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [id]="'start-' + milestone.id"
              [value]="milestone"
              [(ngModel)]="selectedCustomStartMilestone"
            />

            <label class="ml-2" [for]="'start-' + milestone.id">
              <span class="block text-sm font-medium text-gray-700">{{ milestone.name }}</span>

              <span class="block text-xs font-medium text-gray-700">
                ({{ milestone.start_date | date }})
              </span>
            </label>
          </div>
        }
      </div>

      <div class="h-96 space-y-2 overflow-auto p-2">
        <div class="text-xs">Select ending milestone/date:</div>

        <div class="flex flex-1 items-center" (click)="selectDateInputRadio(false)">
          <input
            name="end-milestone-date"
            type="radio"
            class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
            [value]="customMilestoneDatepickerType.END_DATE"
            [(ngModel)]="selectedCustomEndMilestone"
          />
          <div class="ml-2">
            <aux-input
              class="w-40"
              [type]="'date'"
              [placeholder]="formControlConstants.PLACEHOLDER.DATE"
              [formControl]="customEndDateControl"
              [disabled]="isCustomEndDateControlDisabled()"
              [dateCompareValidation]="trialTimelinePeriod"
              dateCompareError="trialTimelinePeriod"
            />
          </div>
        </div>

        @for (milestone of allMilestones; track milestone) {
          <div class="flex flex-1 items-center">
            <input
              name="end-milestone-date"
              type="radio"
              class="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
              [id]="'end-' + milestone.id"
              [value]="milestone"
              [(ngModel)]="selectedCustomEndMilestone"
            />

            <label class="ml-2" [for]="'end-' + milestone.id">
              <span class="block text-sm font-medium text-gray-700">{{ milestone.name }}</span>

              <span class="block text-xs font-medium text-gray-700">
                ({{ milestone.end_date | date }})
              </span>
            </label>
          </div>
        }
      </div>
    </div>
  }
</div>
